import { AreaPage } from '@kanos/web-core';
import { createFileRoute } from '@tanstack/react-router';
import { DutyAdminOnly } from '../firm/duty-admin-only';
import { DutyTabs } from '../firm/duty-tabs';
import { TrainingsCard } from '../firm/trainings-card';
import { TableSearch } from '../table-search';

export const Route = createFileRoute('/obligations/trainings')({
  // The table keeps its view in the address.
  validateSearch: TableSearch,
  component: Trainings,
});

/** The trainings of the firm's people (ADR-083 § 1). */
function Trainings() {
  return (
    <AreaPage title="Pflichten">
      <DutyTabs current="trainings" />
      <DutyAdminOnly>
        <TrainingsCard />
      </DutyAdminOnly>
    </AreaPage>
  );
}
